import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckBusiness = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 800 625.28",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n    " }), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "linear-gradient",
		x1: 10.15,
		y1: 315.36,
		x2: 789.85,
		y2: 315.36,
		gradientTransform: "translate(0 628) scale(1 -1)",
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#00794a"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .18,
				stopColor: "#008c55"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .39,
				stopColor: "#009c5e"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .64,
				stopColor: "#00a563"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00a865"
			})
		]
	})] }), /* @__PURE__ */ _jsx("polygon", {
		className: "st0",
		points: "789.85 106.01 281.13 614.73 185.43 519.28 10.15 344 105.85 248.31 281.13 423.58 694.4 10.56 789.85 106.01"
	})]
});
export default SvgCheckBusiness;
